import { Component, OnInit, HostBinding } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageService } from '../../services/page.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  @HostBinding('class') class = 'ion-page';
  code: string;
  isGen060 = false;
  gen060Message = '';

  constructor(private activatedRoute: ActivatedRoute, private pageService: PageService) { }

  ngOnInit() {
    this.code = this.activatedRoute.snapshot.params.code || '404';

    const errorData = history.state?.errorData || this.pageService.gen060Error;
    this.pageService.gen060Error = null;
    if (errorData?.errorCode === 'GEN060' && Array.isArray(errorData.errorMsg)) {
      this.isGen060 = true;
      const lang = document.documentElement.lang || 'en';
      const match = errorData.errorMsg.find((m: any) => m.languageCode === lang)
        || errorData.errorMsg.find((m: any) => m.languageCode === 'en')
        || errorData.errorMsg[0];
      this.gen060Message = match?.value || '';
    }
  }

  tryAgain() {
    window.history.back();
  }
}
